export class AwsEbsVolumeResource {
    'volumeId';
    'volumeType';
    'sizeGib';
    'iops';
    'throughputMiBs';
    'state';
    'availabilityZone';
    'encrypted';
    'kmsKeyId';
    'isAwsManagedKey';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumeId",
            "baseName": "volumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeType",
            "baseName": "volumeType",
            "type": "AwsEbsVolumeResourceVolumeTypeEnum",
            "format": ""
        },
        {
            "name": "sizeGib",
            "baseName": "sizeGib",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "iops",
            "baseName": "iops",
            "type": "number",
            "format": ""
        },
        {
            "name": "throughputMiBs",
            "baseName": "throughputMiBs",
            "type": "number",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "AwsEbsVolumeResourceStateEnum",
            "format": ""
        },
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "encrypted",
            "baseName": "encrypted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "kmsKeyId",
            "baseName": "kmsKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "isAwsManagedKey",
            "baseName": "isAwsManagedKey",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEbsVolumeResource.attributeTypeMap;
    }
    constructor() {
    }
}
export var AwsEbsVolumeResourceVolumeTypeEnum;
(function (AwsEbsVolumeResourceVolumeTypeEnum) {
    AwsEbsVolumeResourceVolumeTypeEnum["Standard"] = "standard";
    AwsEbsVolumeResourceVolumeTypeEnum["Io1"] = "io1";
    AwsEbsVolumeResourceVolumeTypeEnum["Io2"] = "io2";
    AwsEbsVolumeResourceVolumeTypeEnum["Gp2"] = "gp2";
    AwsEbsVolumeResourceVolumeTypeEnum["Sc1"] = "sc1";
    AwsEbsVolumeResourceVolumeTypeEnum["St1"] = "st1";
    AwsEbsVolumeResourceVolumeTypeEnum["Gp3"] = "gp3";
})(AwsEbsVolumeResourceVolumeTypeEnum || (AwsEbsVolumeResourceVolumeTypeEnum = {}));
export var AwsEbsVolumeResourceStateEnum;
(function (AwsEbsVolumeResourceStateEnum) {
    AwsEbsVolumeResourceStateEnum["Creating"] = "creating";
    AwsEbsVolumeResourceStateEnum["Available"] = "available";
    AwsEbsVolumeResourceStateEnum["InUse"] = "in-use";
    AwsEbsVolumeResourceStateEnum["Deleting"] = "deleting";
    AwsEbsVolumeResourceStateEnum["Deleted"] = "deleted";
    AwsEbsVolumeResourceStateEnum["Error"] = "error";
})(AwsEbsVolumeResourceStateEnum || (AwsEbsVolumeResourceStateEnum = {}));
